<div class="space-10" *ngIf="!loadingState"></div>

<app-opportunity *ngIf="!loadingState" [page]="'home'" (raceDetailsEvent)="changeLoadingState($event)">
</app-opportunity>

<app-loading-screen *ngIf="loadingState"></app-loading-screen>
